<div class="modal-body">
    <button (click)="close();" type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
    <!-- <form> -->
    <h4 class="pageTitle">Screening questions</h4>
    <div class="row">
        <div *ngFor="let question of screeningQuestions; let i=index;">
            <div *ngIf="question.responseType == '1'" class="col-md-12 col-lg-12 pb-1">
                <div class="form-group">
                    <label style="text-transform: unset;">{{i+1}} {{question.screening_question_name || question.title}}</label>
                    <input [(ngModel)]="question.answer" type="input" class="form-control">
                </div>
            </div>

            <div *ngIf="question.responseType == '0'" class="col-md-12 col-lg-12 col-sm-12 pb-2">
                <label>{{i+1}} {{question.screening_question_name || question.title}}</label>
                <div class="customradiobox m-0">
                    <div class="custom_radio m-0">
                        <input [(ngModel)]="question.answer" type="radio" id="yes-{{i}}" name="{{i}}" value="Yes"><label
                            for="yes-{{i}}">Yes</label>
                        <input [(ngModel)]="question.answer" type="radio" id="no-{{i}}" name="{{i}}" value="No"><label
                            for="no-{{i}}">No</label>
                    </div>
                </div>
            </div>

        </div>
        <div class=" col-md-12 col-lg-12 col-sm-12 mt-4">
            <a (click)="applyForJob()" class="commonBtn">Apply</a>
        </div>
    </div>
    <!-- </form> -->
</div>